import { auth, db } from "../config/firebase/firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  sendEmailVerification,
  updatePassword,
  signInWithPopup,

  GoogleAuthProvider,
} from "firebase/auth";
import {doc, getDoc, setDoc, Timestamp} from "firebase/firestore";
import {sendMessageToTelegram} from "./telegramService";

export const doCreateUserWithEmailAndPassword = async (email, password) => {
  const result = await createUserWithEmailAndPassword(auth, email, password);
  await createUserEntityInFirestore(email);
  return result;
};

export const createUserEntityInFirestore = async (email) => {
  if (email) {
    await setDoc(doc(db, "users", email), {
      isAllowed: true,
    });

    await setDoc(doc(db, `users/${email}/bas.token/1`), {
      cvSent: 0,
      expirationDate: Timestamp.fromDate(new Date(Date.now() + 14 * 24 * 60 * 60 * 1000)),
      isEnabled: false,
      sendsInPackage: 15,
      packageType: "Free",
      fastTrackEnabled: false
    });

    await sendMessageToTelegram({
      email: email,
      messageText: "🆕 New User Registered!",
    });

  }
}

export const checkIfUserExists = async (email) => {
  if (!email) return false;

  const userRef = doc(db, "users", email);
  const userSnap = await getDoc(userRef);

  return userSnap.exists();
};

export const doSignInWithEmailAndPassword = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const doSignUpWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  const email = result?.user?.email;
  if(email) {
    const isUserExists = await checkIfUserExists(email);
    if(!isUserExists) {
      await createUserEntityInFirestore(email);
    }
  }
  return result;
};
//todo: leave only 1 menthod since they are a copy of each other
export const doSignInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  const email = result?.user?.email;
  if(email) {
    const isUserExists = await checkIfUserExists(email);
    if(!isUserExists) {
      await createUserEntityInFirestore(email);
    }
  }
  return result;
};

export const doSignOut = () => {
  return auth.signOut();
};

export const doPasswordReset = (email) => {
  return sendPasswordResetEmail(auth, email);
};

export const doPasswordChange = (password) => {
  return updatePassword(auth.currentUser, password);
};

export const doSendEmailVerification = () => {
  return sendEmailVerification(auth.currentUser, {
    url: `${window.location.origin}/report`,
  });
};
